module.exports = __webpack_public_path__ + "static/media/ross.eecd3b15.png";